import { ViewChild } from '@angular/core';
//import { CaptureResolverService } from './../../services/capture-resolver.service';
import { Component, OnInit } from '@angular/core';
import { CaptureService } from 'src/app/services/Capture.service';
import { CentroCostoService } from 'src/app/services/centro-costo.service';
import { PlantService } from 'src/app/services/plant.service';
import { LineaService } from 'src/app/services/linea.service';
import { Response } from "../../interfaces/response";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IPlant } from 'src/app/interfaces/plant';
import { Router } from "@angular/router";
import { ActivatedRoute } from '@angular/router';
import { ICapture } from 'src/app/interfaces/capture';
import { LocationService } from 'src/app/services/location.service';
import { ControlLineaModalComponent } from './control-linea-modal/control-linea-modal.component';





@Component({
  selector: 'app-capture',
  templateUrl: './capture.component.html',
  styleUrls: ['./capture.component.css']
})
export class CaptureComponent implements OnInit {

  @ViewChild("modalSucces", { static: false }) modalExito;



  plants: IPlant[];
  lastPage: number;
  sucursal: string;
  centroCostos: string;
  lineas: string;
  cedula: string;
  nombre_fc: string;
  orden_ceco: string;
  linea: string;
  filtro_linea: string;
  showSalida: number;
  entrega: number;
  observaciones: string;
  //dataFiltros;
  public dataFiltros: any;
  public id_filtro_linea1: any;
  public tipo1: any;
  public parametro1: any;


  id: string;
  fecha_cambio: string;
  resolData: ICapture[];
  dataRegisPers;
  capture;
  dataPers;
  dataApi;
  result: any;
  token = { api_token: `${localStorage.getItem('token')}` };

  public dataCapture: ICapture;

  public latitude;
  public longitude;


  // value: string;
  // isError = false;

  // onError(error) {
  //   console.error(error);
  //   this.isError = true;
  // }

  constructor(
    private centroCostoService: CentroCostoService,
    private plantService: PlantService,
    private lineaService: LineaService,
    private modalService: NgbModal,
    private _ac: ActivatedRoute,
    private router: Router,
    private captureService: CaptureService,
    public locationService: LocationService,
    private ngbModalRef: NgbModal
  ) {

    this.capture = this._ac.snapshot.data.resolData
    this.dataCapture = {
      'id_planta': '',
      'cedula': '',
      'orden_ceco': '',
      'linea': '',
      'filtro_linea': '',
      'latitude': '',
      'longitude': '',
      'showSalida': 0,
      'entrega': 0,
      'observaciones': '',
    }
    // export interface ICapture {
    //   cedula: string;
    //   id_planta: string;
    // }
  }


  ngOnInit(): void {
    //this.router.data.subscribe((data: {capture: ICapture[]}) => {
    //   this.capture= data.capture;
    //});


    console.log(this._ac.snapshot.data.resolData)
    this.capture = this._ac.snapshot.data.resolData
    this.refresh();
    this.getSucursales();

    if (this.capture.id_planta) {
      this.sucursal = this.capture.id_planta;
    }
    if (this.capture.orden_ceco) {
      this.getCentroCostos(this.capture.id_planta);
      this.orden_ceco = this.capture.orden_ceco;
    }
    if (this.capture.linea) {
      this.getLineas(this.capture.orden_ceco);
      this.linea = this.capture.linea;

      this.getShowParams();
      this.filtro_linea = this.capture.filtro_linea;
      this.showSalida = this.capture.showSalida;
      this.entrega = this.capture.entrega;
      this.observaciones = this.capture.observaciones;
    }

    if (this.capture.cedula) {
      this.captureService.addRegister(this.capture).subscribe(
        (res: Response) => {
          console.log(res)
          console.log(this.capture)
          this.result = res;
          this.modalService.open(this.modalExito)
          this.getRegiterPers();
          //this.plants = res.data;
          //this.getCentroCostos();

        }
      )
    }
  }

  addCapture(qr) {

    // if (this.id_filtro_linea1  &&  this.tipo1==2) {
    //   let location = this.getLocation();
    // }
    this.dataCapture = {
      'id_planta': this.sucursal,
      'cedula': '',
      'orden_ceco': this.orden_ceco,
      'linea': this.linea,
      'filtro_linea': this.filtro_linea,
      'latitude': this.latitude,
      'longitude': this.longitude,
      'showSalida': this.showSalida,
      'entrega': this.entrega,
      'observaciones': this.observaciones

    }

    this.captureService.addCapture(this.dataCapture);

    if (this.sucursal && this.orden_ceco && this.linea) {
      if (qr == 1) {
        //this.router.navigate(['/scanner']);
        this.router.navigate(['/barcode']);
      } else {
        this.router.navigate(['/qr']);
      }
    } else {
      this.result = "seleccione Todos los datos";
    }
  }

  addCode() {

    if (this.id_filtro_linea1  &&  this.tipo1==2) {
      // let location = this.getLocation();
    }

    this.dataCapture = {
      'id_planta': this.sucursal,
      'cedula': this.cedula,
      'orden_ceco': this.orden_ceco,
      'linea': this.linea,
      'filtro_linea': this.filtro_linea,
      'latitude': this.latitude,
      'longitude': this.longitude,
      'showSalida': this.showSalida,
      'entrega': this.entrega,
      'observaciones': this.observaciones


    }
    if (this.sucursal && this.orden_ceco && this.linea && this.cedula) {
      this.captureService.addRegister(this.dataCapture).subscribe(
        (res: Response) => {
          console.log(res)
          console.log(this.capture)
          this.result = res;
          this.modalService.open(this.modalExito)
          this.getRegiterPers();
          //this.plants = res.data;
          //this.getCentroCostos();

        }
      )

    } else {
      this.result = "seleccione Todos los datos";
    }
  }





  refresh(currentPage = 1, param1 = null, param2 = null, param3 = null) {

    //console.log(this.sucursal);
    // this.personalService.all(currentPage, this.cedula, this.sucursal, this.orden_ceco).subscribe(
    //   (res: Response) => {
    //     this.personal = res.data;
    //     this.lastPage = res.meta.last_page;
    //   }
    // )
  }
  getSucursales() {
    this.plantService.allRecords().subscribe(
      (res: Response) => {
        this.plants = res.data;
        //this.getCentroCostos();

      }
    )
  }

  getCentroCostos(param2 = null) {
    this.centroCostoService.allRecords(null, param2, null).subscribe(
      (res: Response) => {
        this.centroCostos = res.data;
        this.refresh(1, this.cedula, this.sucursal, this.orden_ceco);
      }
    )
  }

  getLineas(param2 = null) {
    this.lineaService.allRecords(null, param2, null).subscribe(
      (res: Response) => {
        this.lineas = res.data;
        this.refresh(1, this.cedula, this.sucursal, this.orden_ceco);
      }
    )
  }

  getShowParams() {
    this.getFiltro();
    this.getRegiterPers();
  }

  getFiltro() {

    this.dataApi = {
      'linea': this.linea,
      "api_token": this.token.api_token,
    }
    if (this.linea) {
      this.captureService.dataFiltroHora(this.dataApi).subscribe(
        (res: Response) => {
          this.id_filtro_linea1 = res[0].id_filtro_linea;
          this.tipo1 = res[0].tipo;
          this.tipo1 = res[0].tipo;
          this.parametro1 = res[0].parametro;

          if(this.id_filtro_linea1  && res[0].tipo==2){
            this.showSalida=2;
          }

          console.log(this.parametro1)

        }
      )

    } else {
      this.result = "seleccione Todos los datos";
    }

  }

  getRegiterPers() {

    this.dataPers = {
      'fecha_cambio': this.fecha_cambio,
      'linea': this.linea,
      "api_token": this.token.api_token,
    }
    if (this.linea) {
      this.captureService.dataRegisPers(this.dataPers).subscribe(
        (res: Response) => {
          this.dataRegisPers = res;
          console.log(res)

        }
      )

    } else {
      this.result = "seleccione Todos los datos";
    }
  }

  getLocation() {
    this.locationService.getPosition().then(pos => {
      this.latitude = pos.lat;
      this.longitude = pos.lng;
    });
  }

  toggleVisibility(data) {

  }
  // getShowFiltro() {
  //   if (this.showSalida) {
  //     this.mostrarBootstrapModal(null, 'save');
  //   } //else {
  //    // this.addCapture(1);
  //   //}
  // }

  mostrarBootstrapModal(id_fc: number, tipo: string) {
    this.showSalida=1;
    let location = this.getLocation();


    const opts = {
      windowClass: 'myCustomClass'
    };
    //
    const modalRefNgBots = this.ngbModalRef.open(ControlLineaModalComponent, opts);
    //
    modalRefNgBots.componentInstance.id_filtro_linea1 = this.id_filtro_linea1;
    modalRefNgBots.componentInstance.filtro_linea = this.filtro_linea;
    modalRefNgBots.componentInstance.tipo1 = this.tipo1;
    modalRefNgBots.componentInstance.parametro1 = this.parametro1;

    //modalRefNgBots.componentInstance.showSalida1 = this.showSalida;
    //
    modalRefNgBots.componentInstance.closeMyModal = () => {
      modalRefNgBots.close();
    }
    //


    modalRefNgBots.componentInstance.salida.emit();
    modalRefNgBots.componentInstance.salida.subscribe(res => {
      if (res) {
       this.filtro_linea= res[0].filtro_linea;
       this.id_filtro_linea1= res[0].id_filtro_linea1;
       this.tipo1=res[0].tipo1;
       this.parametro1=res[0].parametro1;
       this.entrega=res[0].entrega;
       this.observaciones=res[0].observaciones;
       this.addCapture(1);
       this.showSalida=2;
      }
      //this.refresh();
      modalRefNgBots.close();
    });

  }


}


